var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Badge, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, IconButton, TextField, Typography, useTheme } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useMemo, useState } from 'react';
import { X } from 'react-feather';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { AppConsts } from '../../../../../application/common/constants/app-consts';
import { useGetAllClientsByMachineQuery, useGetClientsListQuery } from '../../../../../application/features/clients/client-api';
import { useAddSerialNumberMutation } from '../../../../../application/features/machines/machine-api';
import useTranslate from '../../../../../localization/helpers';
import AddSerialNumbers from './AddSerialNumbers';
var AddModelsAndSerialNumber = function (_a) {
    var open = _a.open, onClose = _a.onClose, machineId = _a.machineId;
    var theme = useTheme();
    var _b = __read(useState(false), 2), serialNumbersAdded = _b[0], setSerialNumbersAdded = _b[1];
    var _c = useTranslate(), translate = _c.translate, tWithField = _c.tWithField, tWithFunction = _c.tWithFunction;
    var clientsFetching = useGetClientsListQuery().isLoading;
    var _d = __read(useAddSerialNumberMutation(), 2), addSerialNumbers = _d[0], _e = _d[1], isLoading = _e.isLoading, isSuccess = _e.isSuccess;
    var _f = useGetAllClientsByMachineQuery(machineId, {
        skip: !machineId
    }).data, clients = _f === void 0 ? [] : _f;
    var activeClients = useMemo(function () {
        return clients.filter(function (c) { return c.isActive; });
    }, [clients]);
    var _g = useForm({
        defaultValues: {
            machineId: '',
            machineData: [
                {
                    modelNumber: '',
                    serialNumbers: [
                        {
                            serialNumber: ''
                        }
                    ]
                }
            ]
        }
    }), control = _g.control, reset = _g.reset, setValue = _g.setValue, watch = _g.watch, setError = _g.setError, handleSubmit = _g.handleSubmit, errors = _g.formState.errors;
    var _h = useFieldArray({
        name: 'machineData',
        control: control
    }), fields = _h.fields, append = _h.append, remove = _h.remove;
    useEffect(function () {
        if (isSuccess) {
            enqueueSnackbar(tWithField('toolTips.addSuccess', serialNumbersAdded ? 'common.modelSerialNumbers' : 'common.modelNumbers'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            closeDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    var closeDialog = function () {
        reset();
        onClose();
    };
    var handleAddModelNumber = function () {
        var machineData = {
            modelNumber: '',
            serialNumbers: [{ serialNumber: '' }]
        };
        append(machineData);
    };
    var findDuplicateSerialNumber = function (machineData) {
        var allSerialNumbers = machineData.flatMap(function (model, modelIndex) {
            return model.serialNumbers
                .filter(function (s) { return s.serialNumber.trim() !== ''; })
                .map(function (s, serialIndex) { return ({
                serialNumber: s.serialNumber.trim().toLowerCase(),
                modelIndex: modelIndex,
                serialIndex: serialIndex
            }); });
        });
        var serialNumberMap = new Map();
        allSerialNumbers.forEach(function (_a) {
            var serialNumber = _a.serialNumber, modelIndex = _a.modelIndex, serialIndex = _a.serialIndex;
            if (!serialNumberMap.has(serialNumber)) {
                serialNumberMap.set(serialNumber, []);
            }
            serialNumberMap.get(serialNumber).push({ modelIndex: modelIndex, serialIndex: serialIndex });
        });
        var hasDuplicates = false;
        serialNumberMap.forEach(function (occurrences) {
            if (occurrences.length > 1) {
                hasDuplicates = true;
                occurrences.forEach(function (_a) {
                    var modelIndex = _a.modelIndex, serialIndex = _a.serialIndex;
                    setError("machineData.".concat(modelIndex, ".serialNumbers.").concat(serialIndex, ".serialNumber"), {
                        message: tWithField('validations.isUnique', 'assets.serialNumber')
                    });
                });
            }
        });
        return !hasDuplicates;
    };
    var handleSubmitForm = function (machine) {
        var addedSerialNumbers = machine.machineData.flatMap(function (model) { return model.serialNumbers; });
        if (addedSerialNumbers.length > 0)
            setSerialNumbersAdded(true);
        var isValid = findDuplicateSerialNumber(machine.machineData);
        if (isValid) {
            machine.machineId = machineId;
            addSerialNumbers(machine);
        }
    };
    return (_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: open, maxWidth: 'sm', children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [tWithFunction('actions.addFunction', 'assets.modelSerialNumbers'), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: closeDialog, children: _jsx(X, { size: 20, color: '#637381' }) })] }), _jsxs(DialogContent, { dividers: true, sx: {
                    pb: 4,
                    px: 4
                }, children: [_jsx(Box, { component: 'form', noValidate: true, autoComplete: 'off', children: _jsx(Grid, { container: true, spacing: 3, p: 1, children: _jsx(Grid, { size: { xs: 12, md: 12, sm: 12, lg: 12 }, children: _jsx(Controller, { name: 'clientId', control: control, render: function (_a) {
                                        var _b;
                                        var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                        return (_jsx(FormControl, { size: 'medium', fullWidth: true, variant: 'outlined', children: _jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), sx: {
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '8px'
                                                    }
                                                }, loading: clientsFetching, disabled: isLoading, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, value: (_b = activeClients.find(function (client) { return value === client.id; })) !== null && _b !== void 0 ? _b : null, options: activeClients, getOptionLabel: function (option) { return option.name || ''; }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { disabled: isLoading, variant: 'outlined', fullWidth: true, label: translate('common.clients') }))); }, onChange: function (_, value) {
                                                    onChange(value === null || value === void 0 ? void 0 : value.id);
                                                }, renderOption: function (props, option) { return (_createElement("li", __assign({}, props, { key: option.id }), option.name)); } }) }));
                                    } }) }) }) }), _jsxs(Box, { mt: 1, display: 'flex', flexDirection: 'column', gap: '16px', children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', width: '100%', children: [_jsx(Typography, { variant: 'subtitle1', color: theme.palette.grey[700], children: translate('assets.modelNumbers') }), fields.length < AppConsts.SERIAL_NUMBER_LIMIT && (_jsx(Button, { variant: 'outlined', color: 'primary', size: 'medium', onClick: handleAddModelNumber, children: translate('actions.add') }))] }), fields.map(function (field, index) { return (_jsx(Grid, { container: true, spacing: 2, children: _jsx(Grid, { size: { xs: 12 }, children: _jsxs(Box, { p: '8px 16px', gap: 2, flexDirection: 'column', borderRadius: '12px', bgcolor: '#FFFFFF', boxShadow: theme.customShadows.z8, position: 'relative', children: [_jsx(Badge, { overlap: 'circular', badgeContent: index + 1, sx: {
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    zIndex: 10,
                                                    '& .MuiBadge-badge': {
                                                        backgroundColor: '#E4E6EB',
                                                        color: '#161C24'
                                                    }
                                                } }), _jsx(Controller, { name: "machineData.".concat(index, ".modelNumber"), control: control, rules: {
                                                    required: tWithField('validations.fieldIsRequired', 'assets.modelNumber'),
                                                    validate: function (value) {
                                                        var isDuplicate = fields.some(function (item, i) {
                                                            return i !== index && item.modelNumber.toLowerCase() === value.toLowerCase();
                                                        });
                                                        return isDuplicate
                                                            ? tWithField('validations.isUnique', 'assets.modelNumber')
                                                            : true;
                                                    }
                                                }, render: function (_a) {
                                                    var _b, _c, _d, _e, _f;
                                                    var field = _a.field;
                                                    return (_jsxs(FormControl, { fullWidth: true, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', gap: 1, children: [_jsx(TextField, __assign({ size: 'small', label: translate('assets.modelNumber') }, field, { disabled: isLoading, error: !!((_c = (_b = errors.machineData) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.modelNumber), fullWidth: true, children: translate('assets.modelNumber') })), fields.length > 1 && (_jsx(Button, { variant: 'outlined', color: 'error', size: 'medium', onClick: function () { return remove(index); }, children: translate('actions.remove') }))] }), _jsx(FormHelperText, { error: true, children: (_f = (_e = (_d = errors.machineData) === null || _d === void 0 ? void 0 : _d[index]) === null || _e === void 0 ? void 0 : _e.modelNumber) === null || _f === void 0 ? void 0 : _f.message })] }));
                                                } }), _jsx(AddSerialNumbers, { control: control, modelSerialNumberIndex: index, errors: errors, watch: watch, setValue: setValue, isLoading: isLoading })] }) }) }, field.id)); })] })] }), _jsxs(DialogActions, { children: [_jsx(Button, { size: 'medium', variant: 'outlined', color: 'inherit', disabled: isLoading, onClick: closeDialog, children: translate('actions.cancel') }), _jsx(Button, { size: 'medium', variant: 'contained', color: 'inherit', disabled: isLoading, onClick: handleSubmit(handleSubmitForm), children: translate('actions.addAll') })] })] }));
};
export default AddModelsAndSerialNumber;
